module.exports = __webpack_public_path__ + "img/title-professional-small.fd53e19.png";